export default __webpack_public_path__ + "static/media/google-play-badge.90b9a113.png";